import JobsthemeColorsData from "../../js/jobsthemeColorsData";

import {
  Animatespin,
  MainHeading,
  JobsCom,
  HoverButton,
  Footer,
  Navbar,
  Experience,
} from "../../components/index";
import Functions from "./index.function";
export default function JobSave() {
  const {
    jobsSavedJobs,
    allSevedJobs,
    handleJobClick,
    isLoading,
    hasmorepgae,
    loadingapi,
    handledeleteJobClick,
    setCurrentPage,
  } = Functions();
  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:py-5">
        <MainHeading
          title={"Saved Jobs"}
          dis={" "}
          layout={"h-18 sm:h-20 lg:h-36"}
          navigate={"/job-details"}
        />
        <>
          {jobsSavedJobs?.job_applies?.length === 0 ? (
            <p className="text-secondary font-onestLight xs:text-xs sm:text-xs lg:text-sm text-center xs:pt-5 sm:pt-6 lg:pt-8 w-full">
              No Saved Jobs
            </p>
          ) : (
            <div className="lg:mt-8 lg:pt-14 xs:pt-5 sm:py-6 grid xs:grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 xs:gap-y-3 sm:gap-5 xl:gap-7 3xl:gap-12">
              {allSevedJobs?.map((value, index) => (
                <div key={index}>
                  <JobsCom
                    onClick={() => handleJobClick(value?.id)}
                    subtitle={value?.company?.name}
                    jobsTitle={value?.title}
                    jobsDis={value?.description?.split(".")[0] + "."}
                    timingbtnTitle={
                      value?.job_types?.job_type === null
                        ? "Full Time"
                        : value?.job_types?.job_type
                    }
                    salarybtnTitle={`${value?.salary_currency ?? ""}${
                      value?.salary_from
                    } - ${value?.salary_currency ?? ""}${value?.salary_to}`}
                    jobstheme={
                      JobsthemeColorsData[index % JobsthemeColorsData?.length]
                        .jobstheme
                    }
                    btntheme={
                      JobsthemeColorsData[index % JobsthemeColorsData?.length]
                        .btntheme
                    }
                    location={
                      value?.country?.country === null
                        ? "Australia"
                        : value?.country?.country
                    }
                    navigate={() => handleJobClick(value?.id)}
                    isSaved={String(value?.id)}
                    deletejob={() => handledeleteJobClick(value?.id)}
                    loadingToapi={loadingapi}
                    isdeletejob={true}
                  />
                </div>
              ))}
            </div>
          )}
        </>
        {isLoading ? (
          <Animatespin />
        ) : (
          <>
            {hasmorepgae && (
              <div className="flex justify-center items-center lg:pt-10">
                <HoverButton
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  extraClasses={
                    "group xs:w-56 xs:h-8 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle={"Load More Jobs"}
                  BtnTitleClasses={
                    "text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform group-hover:scale-110 group-hover:text-primary"
                  }
                />
              </div>
            )}
          </>
        )}
      </div>
      <Experience />
      <Footer />
    </div>
  );
}
